import close from './close';

export default function closeOrLess(a, b, tolerance) {
    return a < b || close(a, b, tolerance);
}


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/geometry/math/close-or-less.js